import React, { useState } from "react";
import { Link } from "react-router-dom";

function CorporateV1() {
  const [videoModalOpen, setVideoModalOpen] = useState(false);

  return (
    <section className="v1-corp-section">
      <div className="v1-corp-inner">
        {/* Left Column */}
        <div className="v1-corp-left">
          <span className="v1-corp-tag">Corporate Experiences</span>
          <h2 className="v1-corp-title">
            Trusted by Teams.<br />
            <span className="v1-corp-title-blue">Loved by Travelers.</span>
          </h2>
          <p className="v1-corp-desc">
            Real experiences from companies who booked with Weyfarin.
          </p>

          <Link to="/contactus" className="v1-corp-cta-btn">
            <span>Plan a Corporate Event</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>

          {/* 3 Team thumbnails */}
          <div className="v1-corp-thumbnails">
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=400&q=80"
              alt="Team retreat collaboration"
              className="v1-corp-thumb-img"
            />
            <img
              src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=400&q=80"
              alt="Corporate team outdoors"
              className="v1-corp-thumb-img offset"
            />
            <img
              src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=400&q=80"
              alt="Team celebration"
              className="v1-corp-thumb-img"
            />
          </div>
        </div>

        {/* Right Column: Video + Overlapping Testimonial */}
        <div className="v1-corp-right">
          <div className="v1-corp-video-card">
            <img
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1000&q=80"
              alt="TechCorp retreat"
              className="v1-corp-video-bg"
            />
            <div className="v1-corp-video-overlay"></div>

            {/* Client spotlight pill */}
            <span className="v1-client-spotlight-pill">Client Spotlight</span>

            {/* Center Play Button */}
            <button
              type="button"
              className="v1-play-btn"
              onClick={() => setVideoModalOpen(true)}
              aria-label="Play video"
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="#111A2E"
                style={{ marginLeft: "4px" }}
              >
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            </button>

            {/* Bottom Meta Pill */}
            <div className="v1-corp-meta-pill">
              <div className="v1-corp-meta-badge">TC</div>
              <div className="v1-corp-meta-info">
                <strong>TechCorp Australia</strong>
                <small>Annual Retreat</small>
              </div>
            </div>

            {/* Duration pill */}
            <span className="v1-corp-duration-pill">2:45</span>
          </div>

          {/* Overlapping Testimonial Card */}
          <div className="v1-corp-testimonial-card">
            {/* 5 Stars */}
            <div className="v1-testi-stars">
              {[...Array(5)].map((_, i) => (
                <svg
                  key={i}
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="#F5B31A"
                  stroke="#F5B31A"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              ))}
            </div>

            {/* Quote */}
            <blockquote className="v1-testi-quote">
              “Weyfarin made our corporate experience seamless from start to finish.
              The team handled everything professionally, and our employees had an
              amazing time. Highly recommended!”
            </blockquote>

            {/* Author */}
            <div className="v1-testi-author">
              <img
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80"
                alt="Sarah Jenkins"
                className="v1-testi-avatar"
              />
              <div className="v1-testi-author-info">
                <strong>Sarah Jenkins</strong>
                <small>HR Manager, ABC Tech Solutions</small>
              </div>
            </div>

            {/* Feature List */}
            <ul className="v1-testi-feature-list">
              <li className="v1-testi-feature-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>Custom team itineraries</span>
              </li>
              <li className="v1-testi-feature-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>Dedicated event coordinator</span>
              </li>
              <li className="v1-testi-feature-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>Flexible group booking terms</span>
              </li>
              <li className="v1-testi-feature-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>24/7 on-the-ground support</span>
              </li>
            </ul>

            <Link to="/contactus" className="v1-corp-package-btn">
              <span>Explore Corporate Packages</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {videoModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.85)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
          onClick={() => setVideoModalOpen(false)}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "800px",
              background: "#000",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setVideoModalOpen(false)}
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "rgba(255,255,255,0.2)",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "36px",
                height: "36px",
                cursor: "pointer",
                fontSize: "18px",
                zIndex: 10,
              }}
            >
              ✕
            </button>
            <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
              <iframe
                title="Client Spotlight"
                src="https://www.youtube-nocookie.com/embed/ScMzIvxBSi4?autoplay=1"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default CorporateV1;
